var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fair-pay-menu"},[_c(_setup.HorizontalMenu,{attrs:{"items":_vm.items,"value":_vm.value,"size":"small","bottom-line":false},on:{"onChange":_setup.handleOnChange,"onSameTabClick":_setup.handleOnSameTabClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }